import { onCleanup, Show } from "solid-js";
import { fetchResource } from "../../util/fetch";
import { Service } from "../../service/googleprofile/googleprofile";
import { Button, Spinner } from "solid-bootstrap";

export function GoogleProfile(props) {
    const [profile, refetchProfile] = fetchResource(() => Service.getAccountDetails());
    function isAccountLinked() {
        return profile() && profile().is_linked;
    }
    function hasEmailAddress() {
        const prof = profile();
        return prof && prof.email_address && prof.email_address.length > 0;
    }
    function emailAddress() {
        return profile().email_address;
    }
    function lastFetched() {
        const date = new Date(profile().dt * 1000);
        return date.toLocaleDateString();
    }
    function doLinkAccount() {
        Service.getAuthURL().then((authUrl) => {
            window.location.href = authUrl.url;
        });
    }
    function doDelete() {
        Service.deletePrincipalGoogleAccount().finally(() => {
            refetchProfile();
        });
    }

    // Stop polling after 30 minutes.
    const maxPollDuration = 30 * 60 * 1000; // 30 minutes
    const startTime = new Date().getTime();
    const refetchDuration = 3 * 1000; // 3 seconds
    const refetchInterval = setInterval(() => {
        if (hasEmailAddress() || new Date().getTime() - startTime > maxPollDuration) {
            clearInterval(refetchInterval);
            return;
        }
        refetchProfile();
    }, refetchDuration);
    onCleanup(() => {
        clearInterval(refetchInterval);
    });
    return <div class="google-profile">
        <Show when={isAccountLinked()}>
            <h1>Your Google Calendar <i class="fa-brands fa-google"></i> has been linked to Timechief</h1>
            <Show when={!hasEmailAddress()}>
                <p>Google profile not yet synced to Timechief.  Please wait.</p>
                <Spinner animation="border" />
            </Show>
            <Show when={hasEmailAddress()}>
                <p>Account linked to <strong>{emailAddress()}</strong></p>
                <p>Last synced <strong>{lastFetched()}</strong></p>
            </Show>
            <div>Your Google data will remain private.  We do not share your data with third parties.  Your data will be used only for user facing features on your smart device via this cloud service.</div>
            <div class="google-profile-troubleshooting">
                <h2>Troubleshooting</h2>
                <p>If having problems syncing your calendar with Google, you can disassociate Timechief with your Google account using the button below.</p>
                <p>You can check the link between Timechief and your Google third party apps <a href="https://myaccount.google.com/connections?filters=3">here.</a></p>
                <Button onClick={doDelete}>Unlink account</Button>
            </div>
        </Show>
        <Show when={!isAccountLinked()}>
            <h1>Link your Google Calendar <i class="fa-brands fa-google"></i> to Timechief</h1>
            <div class="google-profile-troubleshooting">
                <h2>Troubleshooting</h2>
                <p>You can check the link between Timechief and your Google third party apps <a href="https://myaccount.google.com/connections?filters=3">here.</a></p>
            </div>
            <Button onClick={doLinkAccount}>Link</Button>
            <div>Your Google data will remain private.  We do not share your data with third parties.  Your data will be used only for user facing features on your smart device via this cloud service.</div>
        </Show>
        <div>
        Google Calendar™ calendaring application is a trademark of Google LLC.
        </div>
    </div>
}